










import Vue from "vue";
import Component from "vue-class-component";
import Server from "@/components/arma/Server.vue";
import { ServerInterface } from "@/types";

@Component({
  components: { Server },
  metaInfo: {
    title: "Server Information – Newfound Pioneer Corps Arma 3",
    meta: [
      { vmid: "description", name: "description", content: "Find information about our Arma 3 server here, including the IP and Port, how many players are currently playing and which mod pack it is running." },
      { vmid: "og:title", property: "og:title", content: "Server Information – Newfound Pioneer Corps Arma 3" },
      { vmid: "og:description", property: "og:description", content: "Find information about our Arma 3 server here, including the IP and Port, how many players are currently playing and which mod pack it is running." },
      { vmid: "og:url", property: "og:url", content: "https://arma.npcs.games/server" },
    ],
  },
})
export default class Event extends Vue {
  public contentWidth: number = 768;
  public server: ServerInterface | undefined;
  public loading = true;

  public async mounted() {
    await this.getServerInfo();
    this.loading = false;
  }

  private async getServerInfo() {
    try {
      const apiResponse = await this.axios.get("/arma/server/");
      this.server = apiResponse.data;
    } catch {
      this.server = undefined;
    }
  }
}
